import tenantService from '@/api/tenantService';
import { notify} from '@/utils/notification-helper';


const state = {
    tenantSettings:[],
    addTenant:[],
    formData:{},
    settingsKey:[]

};

const getters = {
};

const actions = {
    async addTenantSettings({commit, rootState}) {
        let payload={
            "TenantID": rootState.tenantData.id,
            "Key":"AllowAuthorize",
            "Value":"true",
            "Description":"To Allow Authorization"
        }
        let res = await tenantService.addTenantSettings(payload)
        commit('addTenantSettings', res.data);
    },
    async getFieldSettingsByKey({commit,rootState}){
        let tenantId = rootState.tenantData.id;
        let res = await tenantService.getTenantSettings(tenantId)
        commit('setFieldSettingsByKey', res.data.data);  
        commit("getObject",res.data.data)
    },
    async save({rootState}){
        console.log("settings",state.settingsKey);
        let payLoad = state.settingsKey.map(v=>{
            return {
                TenantId : rootState.tenantData.id,
                key: v.fieldName,
                value: v.value.toString()
            }
        })
       await tenantService.updateTenantSettings(payLoad).then((res)=>{
        console.log("trip1")
        // let str = res.data.message.split(" ");
        // str.pop()
        // notify(str.join(" "))
        notify(res.data.message)
       }) 
    }

};

const mutations = {
    addTenantSettings(state,item){
        state.addTenant = item
    },
    getObject(state,arr){
        var object = arr.reduce(
            (obj, item) => {
                if(item.fieldType==="Toggle"){
                    item.value=item.value==="true"
                }
                return Object.assign(obj, { [item.fieldName]: item.value })
        }, {});
         state.formData = object 
    },
    inputData(state,val){
        state.formData = val
        state.settingsKey.map(v=>{
            for (const key in val) {
                if(v.fieldName===key){
                    v.value=val[key]
                }
            }
        })
    },
    setFieldSettingsByKey(state,item){
        state.settingsKey = item
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};